/**
 * useStepTimer — hook para medir tiempo humano en pantallas de validación (Fase 61).
 *
 * Devuelve getElapsed() que retorna los segundos transcurridos desde
 * que el componente se montó. Útil para medir timeSpent en P2/P4/P6.
 */

import { useRef, useCallback } from "react";

export function useStepTimer(): () => number {
  const startRef = useRef(Date.now());

  return useCallback(() => {
    return Math.round((Date.now() - startRef.current) / 1000);
  }, []);
}
